import styled from "styled-components";

export const ErrorText = styled("div")`
  color: #d13c1e;
  font-size: 0.75rem;
  line-height: 0.85rem;
  padding-top: 4px;
`;
